import {AxiosError, AxiosResponse} from "axios";
import {injectable} from "inversify";
import {ApiService} from "@/services/apiService";
import {IAccountingSoftwareCodeService, AccountingSoftwareCodesResponse} from "@/injection/interfaces";
import {ItemCode} from "@/types/entities/plan/itemCode";
import {AccountCode} from "@/types/entities/plan/accountCode";

@injectable()
export class AccountingSoftwareCodeService extends ApiService implements IAccountingSoftwareCodeService {

  public async getAccountingSoftwareCodes(type: string): Promise<AccountingSoftwareCodesResponse> {
    const params = `?type=${encodeURIComponent(type)}`;
    const response = await this._httpClient
      .get<AxiosResponse<AccountingSoftwareCodesResponse>>(`${process.env.VUE_APP_API_BASE_URL}/api/accounting-software-codes${params}`)
      .catch(function (error: AxiosError): AxiosResponse<AccountingSoftwareCodesResponse> {
        return error.response as AxiosResponse<AccountingSoftwareCodesResponse>;
      });
    return response.data as AccountingSoftwareCodesResponse;
  }

  public async createItemCode(value: string): Promise<ItemCode> {
    const response = await this._httpClient
      .post<any, AxiosResponse<ItemCode>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/accounting-software-codes/item-codes`,
        { value },
        this.headersWithJsonContentType())
      .catch(function (error: AxiosError): AxiosResponse<ItemCode> {
        return error.response as AxiosResponse<ItemCode>;
      });
    return response.data as ItemCode;
  }

  public async createAccountCode(value: string, name: string): Promise<AccountCode> {
    const response = await this._httpClient
      .post<any, AxiosResponse<AccountCode>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/accounting-software-codes/account-codes`,
        { value, name },
        this.headersWithJsonContentType())
      .catch(function (error: AxiosError): AxiosResponse<AccountCode> {
        return error.response as AxiosResponse<AccountCode>;
      });
    return response.data as AccountCode;
  }
}
